import { getGranularityForDateRange } from './helpers';

export const SET_ACTIVE_PAGE_TYPE = 'dt/application/SET_ACTIVE_PAGE_TYPE';
export const SET_ACTIVE_COMPONENT_ID = 'dt/application/SET_ACTIVE_COMPONENT_ID';
export const SET_ACTIVE_COMPONENT_FILTER = 'dt/application/SET_ACTIVE_COMPONENT_FILTER';
export const SET_ACTIVE_MODEL = 'dt/application/SET_ACTIVE_MODEL';
export const SET_ZOOM_COMPONENT = 'dt/application/SET_ZOOM_COMPONENT';
export const SET_VIEWER_READY = 'dt/application/SET_VIEWER_READY';
export const SET_TIMEZONE = 'dt/application/SET_TIMEZONE';

export const RECEIVE_ACTIVE_COMPONENT = 'dt/application/RECEIVE_ACTIVE_COMPONENT';
export const RECEIVE_POLLING_DATE_RANGE = 'dt/application/RECEIVE_POLLING_DATE_RANGE';
export const RECEIVE_POLLING_INTERVAL = 'dt/application/RECEIVE_POLLING_INTERVAL';

export const REFRESH_VALUES = 'dt/application/REFRESH_VALUES';
export const RECEIVE_REFRESH = 'dt/application/RECEIVE_REFRESH';
export const CLEAR_SITE_DATA = 'dt/application/CLEAR_SITE_DATA';

export const INITIALIZE_POLLING = 'dt/application/INITIALIZE_POLLING';
export const START_POLLING = 'dt/application/START_POLLING';
export const STOP_POLLING = 'dt/application/STOP_POLLING';

export const SET_POLLING_ACTIVE = 'dt/application/IS_POLLING_ACTIVE';
export const SET_POLLING_ACTIVE_DONE = 'dt/application/IS_POLLING_ACTIVE_DONE';
export const CREATE_PANEL_DATE_SUBSCRIPTION = 'dt/application/CREATE_PANEL_DATE_SUBSCRIPTION';
export const DESTROY_PANEL_DATE_SUBSCRIPTION = 'dt/application/DESTROY_PANEL_DATE_SUBSCRIPTION';

export const initializeSitePolling = (siteId) => ({
  type: INITIALIZE_POLLING,
  siteId,
});

export const startSitePolling = () => ({
  type: START_POLLING,
});

export const stopSitePolling = () => ({
  type: STOP_POLLING,
});

export const setActiveComponentId = (id) => ({
  type: SET_ACTIVE_COMPONENT_ID,
  id,
});

export const setActiveComponentFilter = (activeComponentFilter) => ({
  type: SET_ACTIVE_COMPONENT_FILTER,
  activeComponentFilter,
});

export const setPageType = (pageType) => ({
  type: SET_ACTIVE_PAGE_TYPE,
  pageType,
});

export const setZoomComponentId = (id) => ({
  type: SET_ZOOM_COMPONENT,
  id,
});

export const setActiveModelId = (modelId) => ({
  type: SET_ACTIVE_MODEL,
  modelId,
});

export const setViewerReady = (viewerReady) => ({
  type: SET_VIEWER_READY,
  viewerReady,
});

export const setPollingInterval = (pollingInterval) => ({
  type: RECEIVE_POLLING_INTERVAL,
  pollingInterval,
});

export const setPollingDateRange = (pollingDateRange, panelId) => ({
  type: RECEIVE_POLLING_DATE_RANGE,
  pollingDateRange: {
    ...pollingDateRange,
    granularity: getGranularityForDateRange(pollingDateRange),
  },
  panelId,
});

export const setTimezone = (timezone) => ({
  type: SET_TIMEZONE,
  timezone,
});

export const refreshData = (siteId, isInitialLoad = false) => ({
  type: REFRESH_VALUES,
  siteId,
  ...(isInitialLoad && { isInitialLoad }),
});

export const clearSiteData = () => ({
  type: CLEAR_SITE_DATA,
});

export const setPollingActive = (component) => ({
  type: SET_POLLING_ACTIVE,
  component,
});

export const setPollingActiveDone = (component) => ({
  type: SET_POLLING_ACTIVE_DONE,
  component,
});

export const subscribe = (panelId, initializeFromGlobal = true) => ({
  type: CREATE_PANEL_DATE_SUBSCRIPTION,
  panelId,
  initializeFromGlobal,
});

export const unsubscribe = (panelId) => ({
  type: DESTROY_PANEL_DATE_SUBSCRIPTION,
  panelId,
});
